import React from 'react';
export function BonusSection() {
  return <section className="py-16 md:py-24 px-4 bg-navy relative overflow-hidden" data-id="element-66">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy to-navy-dark pointer-events-none" data-id="element-67"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-68">
        {/* Visual bridge — sugar spoons */}
        <div className="text-center mb-16" data-id="element-69">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight mb-3" data-id="element-70">
            Lo que nadie te ha explicado
          </h2>
          <p className="text-lg md:text-xl text-gold font-serif italic mb-8" data-id="element-71">
            Comes eso todos los días sin saberlo
          </p>
          <div className="flex justify-center mb-6" data-id="element-72">
            <img src="https://cdn.magicpatterns.com/uploads/mNdG9AttAmJfefTJZ5q2tQ/Imagen_Seccion_5.png" alt="Alimentos cotidianos y sus cucharaditas de azúcar oculto" className="w-full max-w-md h-auto rounded-2xl shadow-lg border border-white/10" data-id="element-73" />
          </div>
        </div>

        <div className="text-center mb-16" data-id="element-74">
          <span className="inline-block border border-gold/30 bg-gold/10 text-gold font-bold tracking-widest text-sm uppercase px-4 py-1.5 rounded-full mb-6" data-id="element-75">
            🎁 BONOS EXCLUSIVOS
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight mb-4" data-id="element-76">
            3 herramientas prácticas incluidas gratis
          </h2>
          <p className="text-lg md:text-xl text-cream/70 font-sans font-light" data-id="element-77">
            No se venden por separado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-78">
          {/* Bonus 1 */}
          <div className="bg-white rounded-2xl p-8 relative flex flex-col shadow-xl" data-id="element-79">
            <div className="absolute -top-4 -right-4 bg-cta text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg transform rotate-3" data-id="element-80">
              VALOR: $9.95
            </div>
            <div className="flex items-start gap-4 mb-3" data-id="element-81">
              <img src="https://cdn.magicpatterns.com/uploads/h1Q7gG6Jfx4EmLJfgkTuQE/Imagen_Bono_01.png" alt="Los 56 Disfraces del Azúcar" className="w-24 h-auto rounded-lg shadow-md shrink-0" data-id="element-82" />
              <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-83">
                BONO 1<br data-id="element-84" />
                Los 56 Disfraces del Azúcar
              </h3>
            </div>
            <p className="text-gold-dark font-serif italic mb-2" data-id="element-85">
              Guía de bolsillo para el supermercado
            </p>
            <p className="text-navy/80 font-sans text-sm leading-relaxed mb-6 flex-grow" data-id="element-86">
              56 nombres exactos del azúcar oculto + semáforo de colores +
              checklist de 7 preguntas en 60 segundos.
            </p>
            <div className="bg-cream p-4 rounded-lg border border-navy/5" data-id="element-87">
              <p className="text-sm text-navy/70 font-sans flex items-start gap-2" data-id="element-88">
                <span className="text-lg leading-none" data-id="element-89">📱</span>
                <span data-id="element-90">Guárdala en tu teléfono para el supermercado.</span>
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-2xl p-8 relative flex flex-col shadow-xl" data-id="element-91">
            <div className="absolute -top-4 -right-4 bg-cta text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg transform rotate-3" data-id="element-92">
              VALOR: $9.95
            </div>
            <div className="flex items-start gap-4 mb-3" data-id="element-93">
              <img src="https://cdn.magicpatterns.com/uploads/9wnDL68q62kZEPhENvp1Hy/Imagen_Bono_02.png" alt="Los 15 Minutos Después del Plato" className="w-24 h-auto rounded-lg shadow-md shrink-0" data-id="element-94" />
              <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-95">
                BONO 2<br data-id="element-96" />
                Los 15 Minutos Después del Plato
              </h3>
            </div>
            <p className="text-gold-dark font-serif italic mb-2" data-id="element-97">
              Tu mecanismo de rescate científico
            </p>
            <p className="text-navy/80 font-sans text-sm leading-relaxed mb-6 flex-grow" data-id="element-98">
              3 estrategias documentadas para reducir el pico de glucosa cuando
              la comida ya ocurrió. + 6 tarjetas recortables + 10 escenarios
              reales.
            </p>
            <div className="bg-cream p-4 rounded-lg border border-navy/5" data-id="element-99">
              <p className="text-sm text-navy/70 font-sans flex items-start gap-2" data-id="element-100">
                <span className="text-lg leading-none" data-id="element-101">🧲</span>
                <span data-id="element-102">Pega las tarjetas en tu nevera.</span>
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-2xl p-8 relative flex flex-col shadow-xl" data-id="element-103">
            <div className="absolute -top-4 -right-4 bg-cta text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg transform rotate-3" data-id="element-104">
              VALOR: $14.95
            </div>
            <div className="flex items-start gap-4 mb-3" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/1aNVW6uTKrB4CzwRkiyHUf/Imagen_Bono_03.png" alt="7 Días de Platos Reales" className="w-24 h-auto rounded-lg shadow-md shrink-0" data-id="element-106" />
              <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-107">
                BONO 3<br data-id="element-108" />7 Días de Platos Reales
              </h3>
            </div>
            <p className="text-gold-dark font-serif italic mb-2" data-id="element-109">
              Menú semanal anti-glicación + lista de compras
            </p>
            <p className="text-navy/80 font-sans text-sm leading-relaxed mb-6 flex-grow" data-id="element-110">
              7 días con el orden correcto de macronutrientes. Preparación
              dominical de 60 min. Tabla de sustituciones. Viernes y sábado con
              flexibilidad social.
            </p>
            <div className="bg-cream p-4 rounded-lg border border-navy/5" data-id="element-111">
              <p className="text-sm text-navy/70 font-sans flex items-start gap-2" data-id="element-112">
                <span className="text-lg leading-none" data-id="element-113">🛒</span>
                <span data-id="element-114">Ensambla cada cena en 10 minutos.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}